export const LOGOS = [
  {
    src: require('../../../assets/logos/blue-seal.png'),
    alt: 'Blink Health LLC BBB Business Review',
    url: 'https://www.bbb.org/new-york-city/business-reviews/medicine-consultant/blink-health-llc-in-new-york-ny-161740/#sealclick',
    height: 45,
  },
  {
    src: require('../../../assets/logos/legit-script.svg'),
    alt: 'LegitScript approved',
    url: 'https://legitscript.com/pharmacy/blinkhealth.com',
    height: 92,
  },
  {
    src: require('../../../assets/logos/safe-pharmacy.png'),
    alt: 'Safe Pharmacy logo',
    url: 'https://safe.pharmacy/buy-safely/?url=blinkhealth.com',
    height: 71,
  },
];
